import { createRouter, createWebHashHistory } from "vue-router";

import detailsCardView from "@/components/detailsCardView.vue";
import personalsettingView from "@/views/autoprice/setting/personalsettingView.vue";
import historyView from "@/views/goodslist/purchasehistoryView.vue";
import Bus from "@/router/bus";
import autopricepass from "@/views/autoprice/autopricepasskView.vue";
import autopricesetting from "@/views/autoprice/autopricesettingView.vue";
import correspondence from "@/views/autoprice/setting/correspondence.vue";
import redpacketView from "@/views/autoprice/setting/redpacketView.vue";
import devsettingView from "@/views/details/devsettingView.vue";
import Home from "@/views/details/firstinfoView.vue";
import mybuyView from "@/views/details/mybuyView.vue";
import login from "@/views/details/signinView.vue";
import testCrosView from "@/views/goodslist/testCrosView.vue";
import multiplecate from "@/views/multiplecate/multiplecateView.vue";
import realtimedark from "@/views/realtime/realtimedarkView.vue";
const routes = [
    // 默认进入页面--数据首页
    {
        path: "/",
        redirect: "/autopricecheck",
    },
    // 个人信息首页
    {
        path: "/Home",
        name: "Home",
        component: Home,
    },
    // 登录页
    {
        path: "/login",
        name: "login",
        component: login,
        meta: { title: "登录" },
    },
    // 注册页
    {
        path: "/register",
        name: "register",
        component: () => import("@/views/details/signupView.vue"),
        meta: { title: "注册" },
    },
    // 系统下单
    {
        path: "/mybuy",
        name: "mybuy",
        component: mybuyView,
        meta: { title: "系统下单记录" },
    },
    //  账号关联
    {
        path: "/personalsetting",
        name: "personalsetting",
        component: personalsettingView,
        meta: { title: "平台账号" },
    },
    //  历史采购
    {
        path: "/purhistory",
        name: "purhistory",
        component: historyView,
        meta: { title: "手机历史成交" },
    },
    //  管理员设置
    {
        path: "/devsetting",
        name: "devsetting",
        component: devsettingView,
        meta: { title: "管理员设置" },
    },
    //  映射管理
    {
        path: "/correspondence",
        name: "correspondence",
        component: correspondence,
        meta: { title: "机型映射" },
    },
    // 数据页的其他
    {
        path: "/phones",
        name: "phones",
        children: [
            {
                path: "usercard",
                name: "usercard",
                component: testCrosView,
            },
            {
                path: "details",
                name: "details",
                component: detailsCardView,
                meta: { title: "手机详情" },
            },
        ],
    },
    //红包维护
    {
        path: "/redpacket",
        name: "redpacket",
        component: redpacketView,
    },
    // 自动出价配置
    {
        path: "/autopricesetting",
        name: "autopricesetting",
        component: autopricesetting,
    },
    // 自动出价审核
    {
        path: "/autopricecheck",
        name: "autopricecheck",
        component: autopricepass,
    },
    // 多品类
    {
        path: "/multiplecate",
        name: "multiplecate",
        component: multiplecate,
    },
    // 实时竞拍
    {
        path: "/realtimedark",
        name: "realtimedark",
        component: realtimedark,
    }
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

// 路由守卫
router.beforeEach((to, from, next) => {
    //登录及注册页面可以直接进入,而主页面需要分情况
    if (to.path == "/login" || to.path == "/register") {
        next();
    } else {
        if (from.path == "/login") {
            // 从登录页面可以直接通过登录进入主页面
            //next();
            if (localStorage.s === "true") {
                next();
            } else {
                //如果登录状态是false，那么跳转至登录页面,需要登录才能进入主页面
                next("/login");
            }
        } else {
            //从/进入,如果登录状态是true，则直接next进入主页面
            if (localStorage.s === "true") {
                next();
                //显示headercomponent
                Bus.emit("changeMsg", true);
            } else {
                //如果登录状态是false，那么跳转至登录页面,需要登录才能进入主页面
                next("/login");
            }
        }
    }
});

export default router;
